import React, { useContext, useState } from "react"
import { useMutation } from "@apollo/client"
import classNames from "classnames"
import Label from "../../profile/Label"
import { Input } from "../../components/inputs"
import { SIGN_IN } from "../queries"
import { SelectedPlansContext } from "../SelectedPlansContext"
import styles from "../styles.module.scss"

const SignInForm = ({ setShowSignInForm }) => {
  const { setUserType, notifyMessage } = useContext(SelectedPlansContext)
  const [signInDetails, setSignInDetails] = useState({
    email: "",
    password: "",
  })

  const [signIn, { loading: signingIn }] = useMutation(SIGN_IN)

  const handleChange = (e) => {
    setSignInDetails({ ...signInDetails, [e.target.name]: e.target.value })
  }

  return (
    <React.Fragment>
      <div className={classNames(styles.form, styles["account-form"])}>
        <p style={{ margin: "0 0 1rem 0" }}>
          Don&apos;t have an account with us yet?
          <br />
          Fill in your information in the{" "}
          <button
            className={styles.link}
            onClick={() => setShowSignInForm(false)}
          >
            details form
          </button>{" "}
          now.
        </p>

        <div className={styles.items}>
          <div className={styles.row}>
            <div className={styles.item}>
              <Label name="email" />
              <Input
                type="email"
                name="email"
                value={signInDetails.email}
                onChange={handleChange}
              />
            </div>

            <div className={styles.item}>
              <Label name="password" />
              <Input
                type="password"
                name="password"
                value={signInDetails.password}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className={styles.row} style={{ gridTemplateColumns: "1fr" }}>
            <button
              className={styles.button}
              disabled={!signInDetails.email || !signInDetails.password}
              onClick={() =>
                signIn({
                  variables: {
                    email: signInDetails.email,
                    password: signInDetails.password,
                  },
                }).then(({ data }) => {
                  const message = data.signIn.message

                  notifyMessage(message)

                  if (message.type === "success") {
                    setUserType(data.signIn.currentUser.graphqlUserType)
                  }
                })
              }
            >
              {signingIn ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SignInForm
